
import * as Yup from 'yup'



export const AddPurchaseOrderValidation = Yup.object().shape({
    supplier:Yup.object().shape({id:Yup.number().required()}),
    order_no:Yup.string().required(),
    date:Yup.string().required(),
    summary:Yup.string().required(),
    purchaseorderdetail:Yup.array().of(Yup.object().shape({
        glass_id:Yup.number().required()
    })).required()
})